module.exports = __webpack_public_path__ + "src/app/assets/images/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/logo.png
// module id = 584
// module chunks = 0